import { Box, styled } from '@mui/material';
import TransactionAllocator, {
  Transaction,
} from 'components/TransactionAllocator';
import { CurrencyCode, FxDataFeed } from 'further-types/lp/vehicle';
import React from 'react';

const ContentColumn = styled(Box)(({ theme }) => ({
  padding: theme.spacing(
    0,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
  ),
}));

type FeeTransactionAllocatorProps = {
  feeId: string;
  transactions: Array<Transaction>;
  transactionTypeOptions: Array<{ label: string; value: string | null }>;
  vehicle: {
    _id: string;
    baseCurrency: CurrencyCode;
    fxDataFeed: FxDataFeed;
  };
  savedTransactions?: Record<string, Array<Transaction>>;
};

const FeeTransactionAllocator: React.FC<FeeTransactionAllocatorProps> = ({
  feeId,
  transactions,
  transactionTypeOptions,
  vehicle,
  savedTransactions,
}) => {
  //const { setValue, getValues } = useFormContext<PartnerTransfersFormValues>();

  const currentTransactions = savedTransactions?.[feeId] ?? transactions;

  const onTransactionChange = (_updatedTransactions: Array<Transaction>) => {
    //TODO: Save fees transactions in the form
    /*const existingTransactions = getValues('feeTransactions') ?? {};

    setValue('feeTransactions', {
      ...(existingTransactions ?? {}),
      [feeId]: updatedTransactions.map((t) => ({
        ...t,
        id: t.id?.toString(),
        amountExVatLcy: t.amountExVatLcy ?? 0,
        amountIncVatLcy: t.amountIncVatLcy ?? 0,
      })),
    });*/
  };

  return (
    <ContentColumn>
      <TransactionAllocator
        transactionTypeOptions={transactionTypeOptions}
        transactions={currentTransactions}
        onChange={onTransactionChange}
        transactionCurrency={vehicle.baseCurrency}
        fxRate={null}
        vehicle={vehicle}
      />
    </ContentColumn>
  );
};

export default FeeTransactionAllocator;
